module.exports = __webpack_public_path__ + "static/media/binit-illustration-thumbs-up-2.e0c9914d.svg";